module.exports = __webpack_public_path__ + "img/home.7c0dd013.webp";